import React from 'react';
import {
  Box,
  Typography,
  Grid
} from '@mui/material';
import { THEME_COLORS, TYPOGRAPHY } from '../constants';
import ParticipantCard from './ParticipantCard';

/**
 * Composant moderne pour afficher la liste des participants
 */
const ParticipantsList = ({ participants, onRemoveParticipant }) => {
  if (participants.length === 0) return null;

  return (
    <Box sx={{ mb: { xs: 3, sm: 4 } }}>
      {/* Header responsive et plus fin */}
      <Box sx={{ mb: { xs: 2, sm: 3 }, textAlign: 'center' }}>
        <Typography 
          variant="h5" 
          sx={{ 
            fontFamily: TYPOGRAPHY.fontFamily.primary,
            fontWeight: TYPOGRAPHY.fontWeight.semibold,
            color: THEME_COLORS.text.primary,
            fontSize: { xs: TYPOGRAPHY.fontSize.lg, sm: TYPOGRAPHY.fontSize.lg },
            mb: { xs: 0.5, sm: 1 }
          }}
        >
          🎯 Participants inscrits
        </Typography>
        <Typography 
          variant="body1"
          sx={{ 
            color: THEME_COLORS.text.secondary,
            fontFamily: TYPOGRAPHY.fontFamily.primary,
            fontSize: { xs: TYPOGRAPHY.fontSize.sm, sm: TYPOGRAPHY.fontSize.base }
          }}
        >
          {participants.length} participant{participants.length > 1 ? 's' : ''} ajouté{participants.length > 1 ? 's' : ''} à l'activité
        </Typography>
      </Box>

      {/* Grille responsive avec hauteur uniforme */}
      <Grid container spacing={{ xs: 2, sm: 3 }} alignItems="stretch">
        {participants.map((participant, index) => (
          <Grid item xs={12} sm={6} lg={4} key={participant.id || index} sx={{ display: 'flex' }}>
            <ParticipantCard
              participant={participant}
              index={index}
              onRemove={onRemoveParticipant}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ParticipantsList;